import React, { Component, PropTypes } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import URL from 'modules/url'
import * as actions from 'actions'
import * as sempai from 'modules/sempai'
import assets from 'modules/assets'

import Location from './Utils/Location'
import TopWrapper from 'components/Utils/TopWrapper'
import RowThreeText from './Utils/RowThreeText'
import Footer from './Utils/Footer'
import AlertMini from 'components/Utils/AlertMini'


import Timeline from 'components/Utils/Timeline'
import FAQ from 'components/Utils/FAQ'


class Sempai extends Component {
  constructor(props) {
    super(props)
    this.state = { data: null }
  }
  componentDidMount() {
    ReactDOM.findDOMNode(this).scrollIntoView()

    let { dispatch } = this.props
    dispatch(actions.token.fetchData(assets('camps.md')))
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps })
  }
  render() {
    let intro, locationIntro, faq, timeline
    if (this.state.data) {
      intro = sempai.intro(this.state.data)
      locationIntro = sempai.locationIntro(this.state.data),
      faq = sempai.faq(this.state.data),
      timeline = sempai.timeline(this.state.data)
    }
    
    return (
      <main className="page fade-in">
        <AlertMini alertIsMinimized={true} />
        <div className="group0 parallax__group">
          <div className="layer parallax__layer--deep">
            <img src={assets('images/H_Blob-4.png')} style={{width: '50%', height: 'auto'}} />
          </div>

          <div className="layer parallax__layer--base">


            <RowThreeText data={intro} />

            <div className="gakko-video center">
              <iframe src="https://player.vimeo.com/video/150564879" height="100%" frameBorder="0" allowFullScreen></iframe>
            </div>

            <FAQ data={faq}  />
            <div className="filler" style={{height: '1px', marginTop: '10vmin'}}></div>
            <Footer />
          </div>
        </div>
      </main>
    )
  }
}

/*
  <RowThreeText data={locationIntro} />

  <Location data={this.state.data} troupe={'A'} />
  <Location data={this.state.data} troupe={'B'} />

  <Timeline data={timeline} />
*/

Sempai.contextTypes = {
}
Sempai.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
    data: state.token.data
  }
}

export default connect(mapStateToProps)(Sempai)



// WEBPACK FOOTER //
// ./src/components/Sempai.js